import React from "react";
import { useState, useEffect }  from "react";
import { Link } from "react-router-dom";
import Tender from "./Tender";

import {getTranslations} from './Translations'


export default function TenderList(){
    let translations;
    const [tenders, setTenders] = useState([])
    useEffect(() => {
        translations = getTranslations(window.HRMRecruitmentComponentConfiguration?.language);
        
        const apiUrl = window.HRMRecruitmentComponentConfiguration?.apiUrl;
        const language = window.HRMRecruitmentComponentConfiguration?.language;
        const publicationPlaceCode = window.HRMRecruitmentComponentConfiguration?.publicationPlaceCode;

        fetch((apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl) + "/ExternalApi/JobPositionTenderList?language=" +language + (publicationPlaceCode != null ? "&publicationPlaceCode="+publicationPlaceCode: ''), {
            method: "GET"
          })
        //  fetch("list.json")
        .then(res => 
            res.json() 
        )
        .then((result) => {
            // console.log(result);
            if(result.Status == "Error")
            {
                setTenders(null);
                alert(result.Message);
            }
            else
                setTenders(result.Data);
          },(error) => {
               console.log(translations.error);
               console.log(error);
               alert(translations.error+": "+error)
          }
        )
    }, [])

    function renderColumn(tender, col) {

        let link = "/tender/" + tender.Id + "/" + tender.Name;

        switch(col.Type) {

            case 'Button':
                return  (
                    <td scope="row" className={col.Class}>
                        <a href={tender[col.Key].Target}><button>{tender[col.Key].Text}</button></a>
                    </td>
                    )
            case 'Link':
                return  (
                    <td scope="row" className={col.Class}>
                        <a href={tender[col.Key].Target}>{tender[col.Key].Text}</a>
                    </td>
                    )
            case 'DetailsLink':
                return  (
                    <td scope="row" className={col.Class}>
                        <Link to={link}>
                            <>{tender[col.Key]}</>
                        </Link>
                    </td>
                )
            default:
                return  (
                    <td scope="row" className={col.Class}>
                        {tender[col.Key]}
                    </td>                       
                )
        }
    }

    if(tenders?.Columns == null)
    {
        return (
            <div>{translations?.noTenders}</div>
        );
    }

    return (
        <>
        <table className="table tender-list" style={{width:100+"%"}} cellPadding="0" cellSpacing="0"  >
            <thead>
                <tr>
                    {tenders.Columns.map((column, i) => (
                        <th scope="col" className={column.Class}>{column.Title}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                
                {tenders.Tenders.map((tender, i) => (
                    <tr key={tender.Id}>
                         {tenders.Columns.map((col, j) => (
                            <>
                                {renderColumn(tender, col)}
                            </>
                        ))}
                    </tr>    
                ))}

            </tbody>
        </table>
        {/* <Tender /> */}
        </>
    )

    
}
